<template>
  <div class="col-md-12 mx-3" style="background: #fff;">
    <div class="text-center" style="display:block;margin: 10px;">
      <div>
        <a :href="'/tt/ib/' + servicekleber.tib.tag" target="_blank"
          ><img
            class="img-responsive"
            :src="'/tt/tib/' + servicekleber.tib.tag + '/qr.png?size=100'"
        /></a>
      </div>
      <h3>
        {{
          servicekleber.tib.name == servicekleber.tib.name
            ? servicekleber.tib.name
            : servicekleber.tib.name + " " + servicekleber.data.extRef
        }}
      </h3>
      <div>
        {{ servicekleber.address.tib.name }}
        {{ servicekleber.address.data.address }},
        {{ servicekleber.address.data.city }}
      </div>
    </div>
    <hr v-if="servicekleber.address.data.description" />
    <div
      class="md"
      style="display:block;"
      v-html="markedHtml(servicekleber.address.data.description)"
    ></div>
    <hr v-if="servicekleber.data.description" />
    <div
      class="md"
      style="display:block;"
      v-html="markedHtml(servicekleber.data.description)"
    ></div>
  </div>
</template>

<script>
import { markedHtml } from "@/common/utils";
export default {
  name: "servicekleberView",
  data: function() {
    return {
      servicekleber: this.servicekleberProperty,
      markedHtml: markedHtml
    };
  },
  mounted() {
    this.servicekleber = this.servicekleberProperty;
  },
  watch: {
    servicekleberProperty() {
      this.servicekleber = this.servicekleberProperty;
    }
  },
  methods: {},
  props: {
    servicekleberProperty: Object,
    tp: Object
  }
};
</script>
